module.exports = __webpack_public_path__ + "static/media/post-03.94aa54b9.jpg";